'use client';

import React from 'react';
import { useDashboard, type Page } from '@/modules';
import { DashboardPageGrid } from './DashboardPageGrid';

interface DashboardPageProps {
    page: Page;
    onAddWidget: () => void;
    restoredGridContent?: number[][] | null;
    onRestoredGridContentConsumed?: () => void;
}

export function DashboardPage({ page, onAddWidget, restoredGridContent, onRestoredGridContentConsumed }: DashboardPageProps) {

    const { state: { selectedDealer } } = useDashboard();

    if (!selectedDealer) return null;

    return <DashboardPageGrid page={page} onAddWidget={onAddWidget} restoredGridContent={restoredGridContent} onRestoredGridContentConsumed={onRestoredGridContentConsumed} />;
}
